import { LeafCircleIcon } from './LeafCircleIcon';

/**
 * author: Jeff Anders
 * id 30A6559D-F917-44DE-B7C7-9C1AB4DD8BD4
 * name leaf-circle
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/leaf-circle.svg
 * tags
 * - Nature 
 * - Agriculture 
 */
export const OrganicIcon = LeafCircleIcon;
export default OrganicIcon